import { TreeNode } from '../route-builder';

export const CosmosModule = {
  segment: 'cosmos',
  title: '',
  children: {
    CosmosComponent: {
      segment: '',
      title: 'cosmos.title',
      navigationRoot: true,
      children: {
        CosmosSettingsComponent: {
          segment: 'settings',
          icon: 'settings',
          title: 'cosmos.title',
          hideBreadcrumb: true
        },
        PersonalBusinessPartnersComponent: {
          segment: 'personal-business-partners',
          icon: 'handshake',
          title: 'cosmos.business-partners.title'
        }
      }
    }
  }
} as const satisfies TreeNode;
